module.exports = __webpack_public_path__ + "media/images/athletes/3552-af032c0cc3dc04c56d27205b714c28d0.png";